const usersLang = {
  en: {
    users: "Users",
    newUser: "New user",
    updateUser: "Update user",
    responsibility: "Responsibility",
    role: "Role",
    photo: "Photo",
    workgroup: "workgroup",
    user_insert_succesful: "The user has saved correctly",
    generate_file: "Generate file",
    confirm_create_talent_file: "Are you sure you want to create a talent file for this user?",
    talent_file_created_successfully: "Talent file created successfully",
    error_creating_talent_file: "Error creating talent file",
  },
  es: {
    users: "Usuarios",
    newUser: "Nuevo usuario",
    updateUser: "Actualizar usuario",
    responsibility: "Responsabilidad",
    role: "Rol",
    photo: "Foto",
    workgroup: "Grupo de trabajo",
    user_insert_succesful: "El usuario se ha guardado correctamente",
    generate_file: "Generar ficha",
    confirm_create_talent_file: "¿Está seguro de que desea crear una ficha de talento para este usuario?",
    talent_file_created_successfully: "Ficha de talento creada exitosamente",
    error_creating_talent_file: "Error al crear la ficha de talento",
  },
};

export default usersLang;
